import { createContext, useState } from "react";
import PropTypes from "prop-types";

const COUNSELLOR_AUTH_STORAGE_KEY = "counsellor-login-user";

const getStoredCounsellorUser = () => {
  try {
    const storedCounsellorUser = localStorage.getItem(COUNSELLOR_AUTH_STORAGE_KEY);
    return storedCounsellorUser ? JSON.parse(storedCounsellorUser) : null;
  } catch {
    localStorage.removeItem(COUNSELLOR_AUTH_STORAGE_KEY);
    return null;
  }
};

const CounsellorAuthContext = createContext();

export const CounsellorAuthProvider = ({ children }) => {
  const [counsellorUser, setCounsellorUser] = useState(getStoredCounsellorUser);

  const loginCounsellor = (token, userInfo, counsellor, dashboard) => {
    const userData = {
      token,
      role: "Counsellor",
      userInfo,
      counsellor,
      dashboard,
    };

    localStorage.setItem(COUNSELLOR_AUTH_STORAGE_KEY, JSON.stringify(userData));
    setCounsellorUser(userData);
  };

  const logoutCounsellor = () => {
    localStorage.removeItem(COUNSELLOR_AUTH_STORAGE_KEY);
    setCounsellorUser(null);
  };

  const updateCounsellorProfile = (profile) => {
    if (!profile || typeof profile !== "object") return;

    setCounsellorUser((currentUser) => {
      if (!currentUser) return currentUser;

      const updatedUser = {
        ...currentUser,
        userInfo: {
          ...currentUser.userInfo,
          email: profile.email || currentUser.userInfo?.email,
          name: profile.full_name || profile.name || currentUser.userInfo?.name,
          contact_number:
            profile.phone_number ?? currentUser.userInfo?.contact_number,
        },
        counsellor: {
          ...currentUser.counsellor,
          ...profile,
        },
      };

      localStorage.setItem(
        COUNSELLOR_AUTH_STORAGE_KEY,
        JSON.stringify(updatedUser),
      );
      return updatedUser;
    });
  };

  return (
    <CounsellorAuthContext.Provider
      value={{
        counsellorUser,
        loginCounsellor,
        logoutCounsellor,
        updateCounsellorProfile,
      }}
    >
      {children}
    </CounsellorAuthContext.Provider>
  );
};

CounsellorAuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CounsellorAuthContext;
